import Layout from '@/modules/layout/components/layout';
import Permissions from '@/security/permissions';

const ResponsibilitiesList = () => import('@/modules/responsibilities/pages/ResponsibilitiesList.vue');

export default [
    {
        path: '',
        component: Layout,
        meta: { auth: true },
        children: [
            {
                name: 'responsibilities',
                path: '/responsibilities',
                component: ResponsibilitiesList,
                meta: {
                    auth: true,
                    permission: Permissions.values.responsibilityRead,
                }
            },
        ],
    },
];
